import categoryDetailsSymbols from "../symbols/categoryDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CategoryDetailsSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case categoryDetailsSymbols.GET_CATEGORY_DETAILS:
      return { ...state, loading: true, error: false };
    case categoryDetailsSymbols.GET_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case categoryDetailsSymbols.GET_CATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case categoryDetailsSymbols.CLEAR_GET_CATEGORY_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
